var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"w-7 right-2",attrs:{"title":"更多"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_c('i',{staticClass:"fa fa-ellipsis-v"})])
}
var staticRenderFns = []

export { render, staticRenderFns }